var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Btn',{attrs:{"type":"transparent","isLoading":_vm.isRemoving,"padding":"xs"},on:{"click":_vm.removePeak}},[_c('IconMaterial',{attrs:{"title":"close","size":"16"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }